<template>
    <AccordionItem
        :title="title"
        :item="{ taskNr }"
        :should-open="isActive"
        @is-opening="() => $emit('getActiveStep', completeRequirement)"
    >
        <template #bar>
            <div class="acc__item__bar">
                <div class="acc__item__bar__left">
                    <span
                        :class="{
                            'acc__item__bar__trigger__number-icon': true,
                            'is--active': isActive,
                            'is--completed': isCompleted,
                        }"
                    >
                        {{ taskNr }}
                    </span>
                    <span class="acc__item__bar__trigger__title"
                        ><strong>{{ title }}</strong></span
                    >
                </div>

                <span class="acc__item__bar__trigger__icon">
                    <VueFeather type="chevron-down" />
                </span>
            </div>
        </template>
        <template #content>
            <div class="acc__item__content">
                <div class="acc__item__content__desc">
                    {{ desc }}
                </div>
                <div class="onboarding-todo__modal__actions">
                    <RouterLink :to="typeof link === 'string' ? { name: link } : link" class="btn btn--cta">
                        {{ linkHeader }}
                    </RouterLink>
                </div>
            </div>
        </template>
    </AccordionItem>
</template>

<script>
    import AccordionItem from '@components/Accordion/AccordionItem.vue';
    import VueFeather from 'vue-feather';
    import { RouterLink } from 'vue-router';
    import { computed } from 'vue';
    import { useStore } from 'vuex';

    export default {
        components: {
            AccordionItem,
            VueFeather,
            RouterLink,
        },
        props: {
            taskNr: {
                type: Number,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            desc: {
                type: String,
                required: true,
            },
            linkHeader: {
                type: String,
                required: true,
            },
            link: {
                type: [String, Object],
                required: true,
            },
            isActive: {
                type: Boolean,
                required: true,
            },
            completeRequirement: {
                type: String,
                required: true,
            },
        },
        emits: ['getTaskCompleted', 'getActiveStep'],
        setup(props) {
            const store = useStore();
            const isCompleted = computed(() =>
                store.getters['OnboardingStore/GET_ONBOARDING_STEP'](props.completeRequirement)
            );

            return {
                isCompleted,
            };
        },
    };
</script>

<style scoped lang="scss">
    .acc__item__content__desc {
        margin: 16px 0;
    }
    .acc__item__bar__trigger__number-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 2px solid #2b9ce3;
        opacity: 0.3;
        margin-right: 8px;
        color: #2b9ce3;
        flex-shrink: 0;
    }

    .is--active {
        opacity: 1 !important;
    }
    .btn--cta {
        width: 100%;
    }
    .is--completed {
        opacity: 1;
        background-color: #2b9ce3;
        color: #2b9ce3;

        &:after {
            color: white;
            transform: translate(-4px, 0);
            content: '✓';
        }
    }
</style>
